import Home from './pages/Home.js';
import Header from './components/Header.js';

function App() {
  return (
    <>
    <div className='w-screen overflow-hidden'>
      <Header />
      <Home />
    </div>
    </>
  );
}

export default App;
